export default {
    namespaced: true,
    state: {
        isLoading: false,
        isSaving: false,
    },
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setIsSaving(state, isSaving) {
            state.isSaving = isSaving;
        },
    },
    actions: {
        isLoading({ commit }, isLoading) {
            commit('setIsLoading', isLoading);
        },
        isSaving({ commit }, isSaving) {
            commit('setIsSaving', isSaving);
        },
    },
};
